module.exports = __webpack_public_path__ + "static/media/imbacombo5.2fc6afc7.png";